<template>
  <v-container>
    <v-row justify="center" align="center" style="margin-top: 100px">
      <v-col v-for="(company, i) in companies" v-bind:key="company.id" cols="12" xs="12" md="4">
        <v-card @click="setStore(company, i)" :loading="loader && i == index">
          <v-card-title>
            <span style="color: #FF5733">{{ company.Name }}</span>
          </v-card-title>

          <v-card-text></v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
  
  <script>
export default {
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    }
  },
  data() {
    return {
      loader: false,
      shopDialog: false,
      eWalletBalance: null,
      Smsbalance: null,
      CardCode: null,
      quickItem: {},
      cargo: [],
      index: null,
      companies: [],
      warehouseId: 0,
      warehouseName: "",
    };
  },
  methods: {
    openCreate() {
      this.shopDialog = true;
    },
    setStore(company, i) {

      if(this.warehouseId == 0) {
        this.$refs.snackbar.show("Please select a warehouse", "red");
        return;
      }
      this.index = i;
      const self = this;
      localStorage.removeItem("companyName");
      localStorage.removeItem("company_id");
      localStorage.setItem("companyName", company.Name);
      localStorage.setItem("company_id", company.id);
      localStorage.removeItem("store_id");
      localStorage.setItem("store_id", self.warehouseId);
      localStorage.removeItem("storeName");
      localStorage.setItem("storeName", self.warehouseName);
      this.loader = true;
      this.$router.push("/subscriber/dashboard");
    },
    getCompanies() {
      const self = this;
      this.$store
        .dispatch("get", `/companies`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.companies = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDefaultWarehouse() {
      const self = this;
      this.$store
        .dispatch("get", `/default-warehouse`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.warehouseId = res.ResponseData.id;
            self.warehouseName = res.ResponseData.Name;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([this.getCompanies(), this.getDefaultWarehouse()]);
  }
};
</script>
  
  <style lang="scss" scoped>
</style>